module.exports = __webpack_public_path__ + "static/media/5.d5116ff3.jpg";